import {
    Component,
    Input,
    Output,
    EventEmitter,
    HostBinding
} from '@angular/core';

@Component({
    selector: 'app-radio-color',
    template: '<label><input type="radio" [name]="name" /></label>',
    styleUrls: ['./radio-color.component.less']
})
export class RadioColorComponent {
    @Input() name: string = '';
    @Input() value: string = '';

    @HostBinding('style.color') get color() {
        return this.value;
    }

    constructor(
    ) {
    }
}
